import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "ImportCampaignConfigurationResultItemRow" }
const _hoisted_3 = { class: "ImportCampaignConfigurationResultItemTitle" }
const _hoisted_4 = { class: "ImportCampaignConfigurationResultItemSubtitle" }
const _hoisted_5 = { class: "ImportCampaignConfigurationResultItemRow" }
const _hoisted_6 = { class: "ImportCampaignConfigurationResultItemStatus" }
const _hoisted_7 = { class: "ImportCampaignConfigurationResultItemDates" }
const _hoisted_8 = {
  key: 0,
  class: "ImportCampaignConfigurationResultItemOverlapNotice"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["ImportCampaignConfigurationResultItem", { ImportCampaignConfigurationResultItemDisabled: _ctx.isOverlapping }]),
    disabled: _ctx.isOverlapping,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSelect && _ctx.handleSelect(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.campaign.name), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.campaign.id), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.campaign.status), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formattedStartDate) + " - " + _toDisplayString(_ctx.formattedEndDate), 1 /* TEXT */)
    ]),
    (_ctx.isOverlapping)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Dates overlap with the destination campaign "))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}